@for (category of bookCategories$ | async; track category.name.default) {
  @defer (on viewport) {
    <app-book-shelf-drawer [type]="shelfType.Category" [category]="category" class="shelves" />
  } @placeholder {
    <!-- This is needed to calculate the height of the category shelf, otherwise, all the categories shelves will be rendered with a height of 0 px -->
    <app-book-shelf-drawer [type]="shelfType.New" class="shelves" style="opacity: 0" />
  } @error { }
}
